export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10367.f8a6cd7b.jpg";